// dayjs date format: https://day.js.org/docs/en/parse/string-format
export const DEFAULT_DATE_PATTERN: string = 'DD/MM/YYYY';
export const DATE_TIME_PATTERN: string = 'DD MMM YYYY - h:mm A';
export const DATE_TIME_GRID_PATTERN: string = 'DD/MM/YYYY - h:mm A';
export const FULL_DATE_PATTERN: string = 'D MMM YYYY';
export const DATE_PATTERN_VALIDATION = /^\d{2}\/\d{2}\/\d{4}$/;
export const ISO_DATE_FORMAT = /\d{4}\-\d{2}\-\d{2}T\d{2}\:\d{2}\:\d{2}/g;
export const ISO_DATE_FORMAT_WITH_NANOSECONDS = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+/g;
export const BILLING_YEAR_FORMAT = /^[FY]{2}\d{2}$/;

// Unicode date format: https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
export const DEFAULT_DATE_PATTERN_UNICODE: string = 'dd/MM/yyyy';

export const USAGE_HEADER_FILE_NAME_MAX_CHARS = 60;
export const NUMBER_OF_MONTHS_IN_YEAR = 12;

export const CHARS_COUNT_TO_START_SEARCHING: number = 3;
export const SEARCH_DELAY_MS: number = 300;

export const CONTRACT_LINES_PER_PAGE: number = 10;
export const CONTRACTS_PER_PAGE: number = 30;

export const DOCUMENTS_PER_PAGE: number = 30;
export const USAGE_RECORDS_PER_PAGE: number = 10;
export const CONTRACT_SALES_ORDERS_PER_PAGE: number = 10;

export const CONTRACT_LINES_CLIENT_SIDE_PAGINATION_PAGE_TO_LOAD: number = 1;
export const ALL_ITEMS: number = 99999;

export const REACT_ROOT_ID: string = 'react-root';

export const NOT_AVAILABLE_CHAR: string = '-';

export const UPLIFT_UPLOADED_FILES_PER_PAGE = 10;
export const BULK_CL_UPDATE_FILES_PER_PAGE = 10;
export const IMPORTING_TOOL_UPLOADED_FILES_PER_PAGE = 10;

// For currency dropdowns
export const POUND_STERLING_CODE = 826;

export const STOCK_CODE_SEARCH_RESULTS_TO_SHOW = 5;

// the number of contract lines that can fit in the validation error message below, even for the last one.
export const CONTRACT_LINES_AMOUNT_WITH_EXTRA_SPACE_BELOW = 3;

export const REASON_CODES_PER_PAGE = 20;

export const SEARCH_TAGS_TO_SHOW = 7;

export const CUSTOMERS_PER_PAGE = 10;

export const CONTRACT_NUMBER_CHAR_LENGTH_TO_SHOW = 20;

export const SALES_ORDERS_PER_PAGE = 20;

export const MAX_DATABASE_CHARS_LENGTH = 50;
export const MAX_ID_CHARS_LENGTH = 50;

export const CONTRACT_NOTES_PER_PAGE = 10;

export const STATUS_MESSAGE_CHAR_LENGTH_TO_SHOW = 50;

export const BILLING_CYCLES_PER_PAGE = 10;

export const FILE_NAME_ALLOWED_LENGTH = 50;

export const COMMENT_CHARS_VISIBLE_LENGTH = 30;

export const COMMENT_CHARS_ALLOWED_LENGTH = 200;

export const FIELD_VERIFICATIONS_PER_PAGE = 10;

